import { useLocation, useNavigation, useOutletContext } from "react-router-dom";
import { currency } from "remask";

import React, { useEffect } from "react";
import useFooterDefaultOptions from "~components/Footer/hooks/useFooterDefaultOptions";

export const newMoney = (valor) => {
  valor = valor.replace(",", ".");
  return currency.mask({ locale: "pt-BR", currency: "BRL", value: valor });
};

export const money = (valor) => {
  return currency.mask({ locale: "pt-BR", currency: "BRL", value: valor });
};

export const cpfOrCnpjMask = (cpfOrCnpj) => {
  if (!cpfOrCnpj || typeof cpfOrCnpj !== 'string') return "";

  const onlyDigits = cpfOrCnpj.replace(/\D/g, '');

  if (onlyDigits.length === 14) {
    return onlyDigits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  } else if (onlyDigits.length === 11) {
    return onlyDigits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }

  return cpfOrCnpj;
};

export const useConfigureFooter = (options, effect) => {
  const { footerOptions, setFooterOptions } = useOutletContext();
  const { defaultOptions } = useFooterDefaultOptions();

  const path = useLocation().pathname;

  useEffect(() => {
    let newOptions = { ...defaultOptions, path };

    if (options) newOptions = { ...newOptions, ...options };

    const current = footerOptions || {};
    const keys = new Set([...Object.keys(current), ...Object.keys(newOptions)]);
    let changed = false;
    for (const k of keys) {
      if (current[k] !== newOptions[k]) {
        changed = true;
        break;
      }
    }
    if (changed) setFooterOptions(newOptions);
  }, effect ?? []);
};
